import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from '../utils.service'
import { RuntimeService } from '../runtime.service'
import { CriterionService } from '../criterion.service'
import { Criterion } from '../criterion'

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.css']
})
export class AdminPageComponent implements OnInit {
  private tp: string;
  private id: string;
  private target: Criterion

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rts: RuntimeService,
    public utils: UtilsService,
    private cs: CriterionService
  ) {
    this.rts.resetAdminType()
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.tp = params['tp']
      this.id = params['id']
      try {
        if (this.id && this.isEditCriterion)
          this.target = this.cs.get(this.id)
        } catch (e) {
          this.router.navigate(['/'])
        }
    })
  }

  get isNewProject() {
    return this.tp == 'newProject'
  }

  get isNewTopic() {
    let nt = this.tp == 'newTopic'
    if (nt && !this.rts.currentProject)
      this.router.navigate(['projects'])
    return nt
  }

  get isNewSearchTerm() {
    return this.tp == 'newSearchTerm'
  }

  get isNewCriterion() {
    return this.tp == 'newCriterion'
  }

  get isEditCriterion() {
    return this.tp == 'editCriterion'
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-page/admin-page.component.ts